import { createComponent } from '@front/utils/alpine';
import prestashop from 'prestashop';

declare const vehicles: TVehicle[];
declare const product: TProduct;
declare const minPricesByAttribute: any;
declare const groups: TGroups;

const loader = document.querySelector('.js-loader') as HTMLElement;
const loaderOverlay = document.querySelector(
    '.js-loader-overlay'
) as HTMLElement;
const onFinished = new CustomEvent('fetch-finished');

type TVehicle = {
    id_vehicle: string;
    id_model: string;
    begin_date: Date;
    end_date: Date;
    new_materials_available: string;
    template_code: string;
    template_complete_city_set: string;
    template_complete_large_monospace_set: string;
    template_complete_monospace_set: string;
    template_complete_road_set: string;
    template_front_set: string;
    template_rear_set: string;
    template_utility_front_set: string;
    exclusion: string;
    name: string;
    front_description: string;
    rear_description: string;
    rear_description_second_row: string;
};

type TPrice = {
    discount_percentage: number;
    price_displayed: string;
    sale_price_displayed: string;
};

export interface TProduct {
    id: number;
    url: string;
}

type TGroups = {
    [key: string]: TGroup;
};

export interface TGroup {
    group_name: string;
    name: string;
    group_type: string;
    default: number;
    attributes: { [key: string]: Attribute };
    attributes_quantity: { [key: string]: number };
}

export interface Attribute {
    name: string;
    selected: boolean;
}

export default createComponent(() => ({
    $store: {} as { [key: string]: any },

    dropdown: true,

    vehicles,
    product,

    isSeatCover: false,
    isMatOrTrunk: false,

    mobileStepForm: false,
    mobileStep: 1,
    availableSteps: [] as string[],
    steps: [
        {
            value: 'finition',
            products: [5, 7, 8, 9, 13, 19, 21, 22, 27, 30, 32, 37, 38],
        },
        {
            value: 'seats',
            products: [4, 5, 13, 14, 18, 22, 27, 29],
        },
        {
            value: 'customization',
            products: [4, 5, 7, 9, 13, 14, 17, 18, 19, 21, 22, 27, 29, 30, 32, 37, 38],
        },
        {
            value: 'ask-embroidery',
            products: [4, 5, 7, 13, 14, 18, 19, 21, 22, 27, 29, 30],
        },
        {
            value: 'embroidery',
            products: [4, 5, 7, 13, 14, 18, 19, 21, 22, 27, 29, 30],
        },
        {
            value: 'validation',
            products: true,
        },
    ],
    
    vehicle: null as TVehicle | null | undefined,
    choices: [] as string[],

    material: null as number | null,

    pendingRequest: false,

    customization: {
        vehicleId: '',
        templateCode: '',
        embroideryText: '',
        embroideryFont: '',
        embroideryColor: '',
        embroideryIcon: 'aucune',
        embroideryPosition: '',
        embroideryPlacement: '',
        version: '',
        talonnette: '0',
        autogrip: '0',
    },

    embroideryIcons: [
        'AUCUNE',
        'FRANCE',
        'BELGIQUE',
        'ITALIE',
        'ALLEMAGNE',
        'PAYSBAS',
        'ESPAGNE',
        'ANGLETERRE',
        'ALGERIE',
        'MAROC',
        'SUEDE',
        'DANEMARK',
        'POLOGNE',        
        'AUDI',
        'BMW',
        'ELECTRIQUE',
        'HYBRID',
        'CITROEN',
        'PEUGEOT',
        'RENAULT',
        'ZEROONE',
        'GT',
        'RS',
        'SPORT',
        'POWERFULL',
        'COMPTEUR',
        'COEUR',
        'COEUR2',
        'COEUR3',
        'FLEURS',
        'TALON',
        'MOTO',
        'VELO',
        'TAXI',
        'BALLON',
        'SMILEY',
        'SMILEY2',
        'SMILEY3',
        'TREFLE',
        'SNOW',
        'BREIZH',
        'CORSE',
        '64',
        'TAUREAU',
        'ORIGAMI'
    ],

    colors: {
        BLANC: 'color-white',
        GRIS: 'color-grey',
        BEIGE: 'color-beige',
        VIOLET: 'color-purple',
        ROUGE: 'color-red',
        ORANGE: 'color-orange',
        ROSE: 'color-pink',
        VERT: 'color-green',
        JAUNE: 'color-yellow',
        BLEUCLAIR: 'color-lightblue',
        BLEUFONCE: 'color-darkblue',
        ARGENT: 'color-silver',
        OR: 'color-gold',
    },

    colorsOther: {
        BLANC: 'color-white',
        BEIGE: 'color-beige',
        MARRON: 'color-brown',
        ROUGE: 'color-red',
        ORANGE: 'color-orange',
        ROSE: 'color-pink',
        VERT: 'color-green',
        JAUNE: 'color-yellow',
        BLEUFONCE: 'color-darkblue',
        GRIS: 'color-grey',
        NOIR: 'color-black',
    },

    currentColor: '' as string,
    currentMaterial: '' as string,
    currentStyle: '' as string,

    customizationForm: new FormData(),

    colorId: 0 as number | null,

    tierId: null as string | null,

    // Reactive mirror of the size <select> (group 10, baches / product 8).
    // getAttribute(10, true) reads the DOM and is NOT reactive, so stock/price
    // expressions must depend on this instead to re-evaluate when the size changes.
    selectedSize: '' as string,

    attributes: {} as { [key: string]: string },

    inputs: {} as { [key: string]: string },

    prices: {} as { [key: string]: string | null | undefined },

    embroideryImageUrl: '',
    mainImageUrl: '',

    snowSocks: {
        length: null as string | null,
        height: null as string | null,
        diameter: null as string | null,
        status: null as string | null,
    },

    init() {
        if ([19, 21].includes(this.product.id)) {
            const choiceCar = document.querySelector(
                '.choice-car'
            ) as HTMLDivElement;
            if (choiceCar) {
                setTimeout(function () {
                    choiceCar.click();
                }, 1000);
            }
        }

        this.isSeatCover = [4, 14, 18, 29].includes(this.product.id);
        this.isMatOrTrunk = [5, 7, 13, 19, 21, 22, 26, 27, 30].includes(this.product.id);

        // Baches (product 8): keep selectedSize in sync with the size <select>.
        // Initial value from the server-rendered <option selected>, then update
        // on any manual change so stock/price badges stay reactive.
        if (this.product.id === 8) {
            this.syncSelectedSize();
            const sizeSelect = document.querySelector(
                'select[data-product-attribute="10"]'
            ) as HTMLSelectElement | null;
            sizeSelect?.addEventListener('change', () => this.syncSelectedSize());
        }

        for (const step of this.steps) {
            if (typeof step.products === 'boolean' && step.products) {
                this.availableSteps.push(step.value);
            }

            if (
                typeof step.products === 'object' &&
                step.products.includes(this.product.id)
            ) {
                this.availableSteps.push(step.value);
            }
        }

        this.disabledAddToCart();

        prestashop.on('updatedProduct', (event) => {
            this.pendingRequest = false;
            this.prices = this.getActualPrice();
            this.tryEnableAddToCart();
        });

        const cover = document.querySelector(
            '.js-cover-img'
        ) as HTMLImageElement;
        this.mainImageUrl = cover?.src ?? '';

        this.$watch('$store.vehicle', (vehicle: TVehicle) => {
            // this.customization.vehicleId = vehicle.id_vehicle;
            // this.customization.templateCode = vehicle.template_code;
            // this.mobileStepForm = true;
            if (vehicle) {
                this.customization.vehicleId = vehicle.id_vehicle;
                this.customization.templateCode = vehicle.template_code;

                const currentScroll = window.scrollY;

                this.mobileStepForm = true;
                this.mobileStep = 1;

                window.scrollTo(0, currentScroll);
            }
        });

/*        this.$watch('mobileStepForm', () => {
            if (this.mobileStepForm) {
                if (window.innerWidth < 767 && this.product.id != 21)
                    // Fix screen freeze when selecting vehicle.
                   // document.body.classList.add('overflow-hidden', 'h-screen');

                this.mobileStep = 1;
            } else {
                document.body.classList.remove('overflow-hidden', 'h-screen');
            }
        });*/

        this.$watch('mobileStepForm', () => {
            if (this.mobileStepForm) {
                if (window.innerWidth < 767 && this.product.id != 21) {
                    document.body.style.overflow = 'auto';
                    document.body.style.position = 'static';
                }
                this.mobileStep = 1;
            } else {
                document.body.style.overflow = '';
                document.body.style.position = '';
            }
        });

        this.$watch('mobileStep', (step: number) => {
            if (step === 0) {
                this.mobileStepForm = false;
                this.vehicle = null;
                this.$store.vehicle = null;
                //document.body.classList.remove('overflow-hidden', 'h-screen');
            }
        });

        this.$watch('customization', () => {
            this.embroideryImageUrl = this.getEmbroideryImageUrl();
            this.setCustomization();
        });

        this.$watch('tierId', () => {
            const option = document.querySelectorAll(
                    '.js-seat-option[data-attribute-id="74"]'
                ),
                option2 = document.querySelectorAll(
                    '.js-seat-option[data-attribute-id="112"]'
                );

            if (
                parseInt(this.tierId ?? '') === 96 ||
                parseInt(this.tierId ?? '') === 97
            ) {
                option.forEach((item) => {
                    item.classList.add('hidden');
                });
                option2.forEach((item) => {
                    item.classList.add('hidden');
                });
            } else {
                option.forEach((item) => {
                    item.classList.remove('hidden');
                });
                option2.forEach((item) => {
                    item.classList.remove('hidden');
                });
            }


            // Watch and update option Second Tapis
            const selectorAccessoriesPrice = document.querySelector(
                '.ProductSelectorAccessoriesPrice .js-modal-product-price'
            ) as HTMLElement;

            const productsAccessories = document.querySelectorAll('.js-product-accessories .js-product-miniature');
            if(productsAccessories.length > 0) {
                let productAccessoriesElement = productsAccessories[0] as HTMLElement;
    
                const productPageId = document.querySelector('#product_page_product_id') as HTMLInputElement;
                // Lógica de selección de producto según el ID
                if ([5, 13, 19, 22, 27, 30].includes(parseInt(productPageId.value))) {
                    const rangePageAttributeId = this.getSelectedTier() as Number | null;
                    if (rangePageAttributeId == 96) {
                        productAccessoriesElement = productsAccessories[1] as HTMLElement;
                    } else if (rangePageAttributeId == 97) {
                        productAccessoriesElement = productsAccessories[2] as HTMLElement;
                    }
                }
        
                let selectorOptionPrice = productAccessoriesElement.querySelector('.price')?.innerHTML as string;
                selectorAccessoriesPrice.innerHTML = selectorOptionPrice.replace(/(\s*zł|\s*kr\.|\s*€)/g, "").replace(/&nbsp;/g, "");
            }

        });

        this.$watch('attributes', () => {
            this.embroideryImageUrl = this.getEmbroideryImageUrl();

            this.tryEnableAddToCart();
        });

        const addToCartBtn = document.querySelector(
            '.js-add-to-cart-btn'
        ) as HTMLButtonElement;


        addToCartBtn?.addEventListener('click', async (e) => {
            const that = this;

            if (document.querySelector('.js-product-customization')) {
                e.preventDefault();
                const customization = document.querySelector(
                    '.js-product-customization-form'
                ) as HTMLFormElement;

                // Eliminamos el evento submit anidado y lo manejamos directamente
                e.preventDefault();
                loader.style.display = 'block';
                loaderOverlay.style.display = 'block';
                document.body.classList.add('overflow-hidden', 'h-screen');

                // Manejo de los mensajes de customización
                let productMessage = document.querySelectorAll('.js-product-message');
                productMessage[0].textContent = this.customization.vehicleId;

                let productQuestion = document.querySelector('.js-tpl-code-response') as HTMLInputElement | null;

                if (productMessage[1]) {
                    if(productQuestion?.value !== '') {
                        this.customization.templateCode = productQuestion?.value || '';
                    }
                    productMessage[1].textContent = this.customization.templateCode;
                }
                if (productMessage[2]) {
                    productMessage[2].textContent = this.customization.embroideryText;
                }
                if (productMessage[3]) {
                    productMessage[3].textContent = this.customization.embroideryFont;
                }
                if (productMessage[4]) {
                    productMessage[4].textContent = this.customization.embroideryColor;
                }
                if (productMessage[5]) {
                    productMessage[5].textContent = this.customization.embroideryIcon;
                }
                if (productMessage[6]) {
                    productMessage[6].textContent = this.customization.embroideryPosition;
                }
                if (productMessage[7]) {
                    productMessage[7].textContent = this.customization.embroideryPlacement;
                }

                let talonnette = document.querySelector('.js-product-talonnette') as HTMLElement;
                if (talonnette && productMessage[8]) {
                    if (talonnette?.classList.contains('pointer-events-none')) {
                        productMessage[8].textContent = '';
                    } else if (this.customization.talonnette === '1') {
                        productMessage[8].textContent = 'avec';
                    } else {
                        productMessage[8].textContent = '';
                    }
                }

                if (this.product.id === 18) {
                    productMessage[8].textContent = this.customization.version;
                }

                if (productMessage[9]) {
                    productMessage[9].textContent = this.customization.autogrip;
                }
                
                const searchParams = new URLSearchParams();
                for (const [key, value] of that.customizationForm.entries()) {
                    let finalValue = value;
                    if (value === '' && this.$store.needAnswer === true) {
                        const textFieldId = `textField${key.replace('textField', '')}`;
                        const textField = document.getElementById(textFieldId) as HTMLTextAreaElement;
                        finalValue = textField?.value || '';
                        searchParams.append(key, finalValue.toString());
                    } else {
                        searchParams.append(key, value.toString());
                    }
                    
                }

                /* OLD customizationFormSearchParams
                const customizationFormSearchParams = Array.from(
                    that.customizationForm,
                    ([key, value]) => [
                        key,
                        typeof value === 'string' ? value : value.name,
                    ]
                ); */
                
                //const data = new URLSearchParams(customizationFormSearchParams).toString() + '&submitCustomizedData=';
                const data = searchParams.toString() + '&submitCustomizedData=';

                try {
                    const response = await fetch(customization.action+ '?ajax=1', {
                        method: customization.method,
                        body: data,
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    });

                    if (response.status === 200) {
                        const respJson = await response.json();
                        const eventOnFinished = new CustomEvent('fetch-finished', {
                            detail: { success: true, id_customization: parseInt(respJson.id_customization) }
                        });
                        window.dispatchEvent(eventOnFinished);
                        const toggle = document.querySelector('[role="switch"][data-extra-driver]');
                        const isExtraDriverSelected = toggle?.getAttribute('aria-checked') === 'true';

                        if (isExtraDriverSelected) {
                            try {
                                await that.addAccessoryToCart();
                            } catch (error) {
                                console.error('Error adding extra driver:', error);
                            }

                            setTimeout(() => {
                                that.goToCart();
                            }, 1000);
                        } else {
                            setTimeout(() => {
                                that.goToCart();
                            }, 1000);
                        }
                    }

                    
                } catch (error) {
                    console.error('Error:', error);
                }

                // customization.dispatchEvent(new Event('submit', { cancelable: true }));
            } else {
                // Deferred so the click event finishes bubbling first: cart.js's
                // delegated add-to-cart handler registers its 'fetch-finished'
                // listener during the bubble phase (this handler runs during the
                // target phase, earlier), so dispatching synchronously here would
                // fire before anyone is listening and the item would never be added.
                setTimeout(() => window.dispatchEvent(onFinished), 0);
                const toggle = document.querySelector('[role="switch"][data-extra-driver]');
                const isExtraDriverSelected = toggle?.getAttribute('aria-checked') === 'true';

                if (isExtraDriverSelected) {
                    try {
                        await that.addAccessoryToCart();
                    } catch (error) {
                        console.error('Error adding extra driver:', error);
                    }
                }

                setTimeout(() => {
                    that.goToCart();
                }, 1000);
            }
        });

        // window.addEventListener('resize', (e) => {
        //     if (window.innerWidth > 767 && this.mobileStepForm)
        //         document.body.classList.remove('overflow-hidden', 'h-screen');
        //     else if (
        //         window.innerWidth < 767 &&
        //         this.mobileStepForm &&
        //         this.product.id != 21
        //     )
        //         document.body.classList.add('overflow-hidden', 'h-screen');
        // });
    },

    get actualStep(): string {
        return this.availableSteps[this.mobileStep - 1];
    },

    tryEnableAddToCart() {
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';
        //console.log('productSelector tryEnableAddToCart', this.product.id, this.vehicle, this.attributes, this.material);
        //console.log(this.material, this.attributes[2], this.attributes[8], this.attributes[3], this.attributes[20]);

        // Rupture de stock : si la combinaison sélectionnée est à 0, on garde le
        // bouton désactivé. Même source que l'affichage du stock (getStockForAttributes,
        // défini dans product-selector.tpl) : ne renvoie une valeur que lorsque tous les
        // attributs de la combinaison sont choisis, sinon null (on n'interfère pas).
        const selectedStock = (window as any).getStockForAttributes?.([
            ...Object.values(this.attributes),
            this.selectedSize,
        ]);
        if (selectedStock !== null && selectedStock !== undefined && selectedStock <= 0) {
            this.disabledAddToCart();
            return;
        }

        if (
            [4, 14, 18, 29].includes(this.product.id) &&
            !!this.vehicle &&
            !!this.attributes[9] &&
            !!this.material &&
            !!this.attributes[this.material]
        ) {
            this.enableAddToCart();
        } else if (
            this.product.id === 8 &&
            !!this.vehicle &&
            !!this.attributes[12]
        ) {
            this.enableAddToCart();
        } else if (
            this.product.id === 13 &&
            !!this.vehicle &&
            !!this.attributes[8] &&
            !!this.material &&
            !!this.attributes[2]
        ) {
            this.enableAddToCart();
        } else if (
            this.product.id === 17 &&
            !!this.vehicle &&
            !!this.colorId &&
            !!this.attributes[15]
        ) {
            this.enableAddToCart();
        } else if (
            this.product.id === 26 &&
            !!this.vehicle &&
            !!this.colorId &&
            !!this.attributes[20]
        ) {
            this.enableAddToCart();
        } else if (
            !!this.vehicle &&
            !!this.tierId &&
            !!this.colorId &&
            !!this.attributes[`${this.material}`]
        ) {
            this.enableAddToCart();
        } else if (
            [9, 32, 37, 38].indexOf(this.product.id) !== -1 &&
            !!this.vehicle &&
            !!this.snowSocks.status
        ) {
            this.enableAddToCart();
        } else {
            this.disabledAddToCart();
        }
    },

    getSelectedAccessoryElement(): HTMLElement | null {
        const products = document.querySelectorAll(
            '.js-product-accessories .js-product-miniature'
        );

        if (products.length === 0) {
            return null;
        }

        let productElement = products[0] as HTMLElement;
        const productId = document.querySelector(
            '#product_page_product_id'
        ) as HTMLInputElement;

        if (
            productId &&
            Number(productId.value) &&
            [5, 13, 19, 22, 27, 30].includes(Number(productId.value))
        ) {
            const rangeAttributeId = this.getSelectedTier?.();
            const numericRangeAttributeId =
                typeof rangeAttributeId === 'string'
                    ? Number(rangeAttributeId)
                    : rangeAttributeId;

            if (numericRangeAttributeId === 96) {
                productElement = products[1] as HTMLElement;
            } else if (numericRangeAttributeId === 97) {
                productElement = products[2] as HTMLElement;
            }
        }

        return productElement;
    },

    async addAccessoryToCart(): Promise<boolean> {
        const productElement = this.getSelectedAccessoryElement();

        if (!productElement) {
            return false;
        }

        const accessoryBtn = productElement.querySelector(
            '.js-product-btn'
        ) as HTMLButtonElement;

        if (!accessoryBtn) {
            return false;
        }

        const form = accessoryBtn.closest('form') as HTMLFormElement | null;

        if (!form) {
            return false;
        }

        const params = new URLSearchParams(new FormData(form) as any);
        params.set('add', '1');
        params.set('action', 'update');
        params.set('ajax', '1');

        try {
            const response = await fetch(form.action, {
                method: 'POST',
                body: params.toString(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });

            if (!response.ok) {
                return false;
            }

            const resp = await response.json();

            if (resp.hasError) {
                return false;
            }

            prestashop.emit('updateCart', {
                reason: {
                    idProduct: resp.id_product,
                    idProductAttribute: resp.id_product_attribute,
                    idCustomization: resp.id_customization,
                    linkAction: 'add-to-cart',
                    cart: resp.cart,
                },
                resp,
            });

            return true;
        } catch (error) {
            console.error('Error adding accessory product:', error);

            return false;
        }
    },

    goToCart() {
        loader.style.display = 'none';
        loaderOverlay.style.display = 'none';

        if (window.innerWidth > 767) {
            document.body.classList.remove('overflow-hidden', 'h-screen');
        }

        window.location.href = '/panier?action=show';
    },

    disabledAddToCart() {
        const addToCartBtn = document.querySelector(
            '.js-add-to-cart-btn'
        ) as HTMLButtonElement;

        addToCartBtn.setAttribute('disabled', 'disabled');
        loader.style.display = 'none';
        loaderOverlay.style.display = 'none';
        this.pendingRequest = false;
    },

    enableAddToCart() {
        if (this.pendingRequest) {
            return;
        }

        const addToCartBtn = document.querySelector(
            '.js-add-to-cart-btn'
        ) as HTMLButtonElement;

        addToCartBtn.removeAttribute('disabled');
        loader.style.display = 'none';
        loaderOverlay.style.display = 'none';
        if (window.innerWidth > 767)
            document.body.classList.remove('overflow-hidden', 'h-screen');
    },

    addToCart() {
        this.mobileStepForm = false;
        this.enableAddToCart();
        const btn = document.querySelector(
            '.js-add-to-cart-btn'
        ) as HTMLButtonElement;
        btn?.click();
        this.goToCart();
    },

    registerInput(name: string, id: string) {
        this.inputs[name] = id;
    },
    /**
     * Read the current size <select> (group 10) value into the reactive
     * `selectedSize` state so Alpine expressions depending on it re-evaluate.
     */
    syncSelectedSize() {
        const select = document.querySelector(
            'select[data-product-attribute="10"]'
        ) as HTMLSelectElement | null;
        if (select) {
            this.selectedSize = select.value;
        }
    },
    async checkSizeBaches(id: string) {

        const metaCarCover = document.querySelector(
            `meta[name="template_code_car_cover"][data-vehicle-id="` + id + `"]`
        ) as HTMLInputElement;
        const metaCarCoverValue = metaCarCover ? metaCarCover.getAttribute('value') : '';
        if (metaCarCoverValue) { 
            // attribute 10 _ size 
            const selectSize = document.querySelector(
                `.product-variants-item >  select[data-product-attribute="10"]`
            ) as HTMLFormElement;
            if (selectSize) {
                for (const option of selectSize.options) {
                        option.selected = false;
                        option.removeAttribute('selected');
                }
                for (const option of selectSize.options) {
                    if (option.value === metaCarCoverValue) {
                        option.selected = true;
                        option.setAttribute('selected', 'selected');
                        option.dispatchEvent(new Event('change'));
                    }
                }
                // Update reactive state so stock/price badges recompute on the
                // vehicle's real size (option's non-bubbling change won't).
                this.selectedSize = metaCarCoverValue;
            }
        }
    },
    async getQuestion() {


        try {
            const response = await fetch(
                `/modules/tailor/webservice/questions-ajax.php?id_product=${this.product.id}&id_vehicle=${this.vehicle?.id_vehicle}`
            );

            const content = await response.json();
            const tpl = document.querySelector(
                `meta[name*=template][data-vehicle-id="${this.vehicle?.id_vehicle}"]`
            ) as HTMLInputElement;

            this.$store.needAnswer = content.has_questions;

            // Disable/enable choice inputs based on whether questions need to be answered
            if (content.has_questions) {
                let eventype;
                if (this.product.id === 7) { eventype = 'finition'; }
                if (this.product.id === 4 || this.product.id === 14) { eventype = 'seats'; }
                if (eventype) {
                    const choicesGrp = document.querySelectorAll(`.event-${eventype} input`);
                    choicesGrp.forEach((element) => {
                        element.setAttribute('disabled', 'disabled');
                    });
                }
            } else {
                // Re-enable inputs when no questions needed
                let eventype;
                if (this.product.id === 7) { eventype = 'finition'; }
                if (this.product.id === 4 || this.product.id === 14) { eventype = 'seats'; }
                if (eventype) {
                    const choicesGrp = document.querySelectorAll(`.event-${eventype} input`);
                    choicesGrp.forEach((element) => {
                        element.removeAttribute('disabled');
                    });
                }
            }

            if (!content.has_questions && this.vehicle && tpl) {
                this.vehicle.template_code = tpl.value;
                if (this.$refs.questions) this.$refs.questions.innerHTML = '';
                return;
            }

            // The questions container only exists when the product has questions in the template
            if (!this.$refs.questions) return;

            this.$refs.questions.innerHTML = content.questions_form;
            this.$store.modalQuestion = true;

            if (window.innerWidth < 767 && this.$store.modalQuestion)
                document.body.classList.add('overflow-hidden', 'h-screen');
        } catch (err) {
            console.warn("Error getQuestion:", err);
        }
    },

    getVehicleImgDir(): string {
        if (this.product && [4, 14, 18, 29].includes(this.product.id)) {
            return 'tailor_vehicle_seat_cover';
        }

        return 'tailor_vehicle';
    },

    toMMYYYY(date: string): string {
        let objectDate = new Date(date);

        if (isNaN(Date.parse(date))) {
            objectDate = new Date();
        }

        let formattedMonth = '' as string;

        if (objectDate.getMonth() + 1 < 10) {
            formattedMonth = `0${objectDate.getMonth() + 1}`;
        } else {
            formattedMonth = `${objectDate.getMonth() + 1}`;
        }

        let ymd = `${formattedMonth}/${objectDate.getFullYear()}`;

        return ymd;
    },

    get colorList() {
        if (this.product && [4, 14, 18, 29].includes(this.product.id)) {
            return this.colorsOther;
        }

        return this.colors;
    },

    getEmbroideryImageUrl() {
        let url = '';

        const finitionUrl = this.attributes[this.inputs.finition];
        const seatsUrl = this.attributes[this.inputs.seats];
        const color = this.attributes[this.inputs.coloris];
        const colorOutline = this.attributes[`${this.material}`];

        if (this.tierId) {
            url = this.tierId;
        }


        if (finitionUrl) {
            url += finitionUrl;
        }


        if (seatsUrl && ((this.isMatOrTrunk && !color) || this.isSeatCover)) {
            if (url) {
                url += '-';
            }
            url += seatsUrl;
        }

        if (color) {
            if (url && !this.isSeatCover) {
                url += '-';
            }
            url += color;
            //url += `-${color}`;
        }

        if (colorOutline) {
            if (url) {
                url += '-';
            }
            url = this.isSeatCover ? `${colorOutline}` : url + colorOutline;

            //url += `-${colorOutline}`;
        }
        //console.log('Final URL:', `/themes/sweetco/assets/img/custom/${url}.jpg`);

        const type = (this.customization.embroideryPosition || 'CLASSIC').toLowerCase();

        return `/medias/custom/${type}/${url}.jpg`;
    },

    validateUrl(url: string): string | boolean {
        if (url.includes('null')) {
            return '';
        }

        return url;
    },

    /**
     * Get price corresponding to the selected attributes
     *
     * @param { string } tierId The id of the "tier" (gamme)
     * @param { string } optionalId The id of the optional attribute such as stitching id
     * @returns { string | null } The price with the currency symbol
     */
    getPrice(tierId?: string, optionalId?: string): string | null {

        //console.log('Price Debug:' +   tierId, optionalId, { minPricesByAttribute } );

        if (!tierId && optionalId && optionalId in minPricesByAttribute) {
            const { min_prices } = minPricesByAttribute[optionalId];
            return (
                min_prices?.sale_price_displayed ?? min_prices?.price_displayed
            );
        }

        if (!tierId) {
            return null;
        }

        try {
            const tierIdNum = parseInt(tierId, 10);

            const { [tierIdNum]: attribute } = minPricesByAttribute;
            const { min_prices: pricing }: { min_prices: TPrice } = optionalId
                ? attribute[optionalId]
                : attribute;

            return pricing.sale_price_displayed ?? pricing.price_displayed;
        } catch {
            if (!optionalId) {
                return null;
            }

            const { min_prices } = minPricesByAttribute[optionalId];

            return (
                min_prices?.sale_price_displayed ?? min_prices?.price_displayed
            );
        }
    },

    /**
    * Get decli price
    *
    * @param { string } [tierId] The id of the "tier" (gamme)
    * @param { string } [optionalId] The id of the optional attribute such as stitching id
    * @param { string } [type] The type of decli price to retrieve: 'price', 'old', 'discount'
    * @returns { string | null } The decli price with the currency symbol
    */
    getDecliPrice(tierId?: string, optionalId?: string, type?: string): string | null | undefined {

        //console.log('Decli Price Debug:' + type, { tierId, optionalId, type, minPricesByAttribute });

        if( tierId != '97') {
            //const tierIdDiscount = document.querySelector('#tierIdDiscount'+optionalId); tierIdDiscount?.classList.remo('hidden');
            //const tierIdOld = document.querySelector('#tierIdOld'+optionalId); tierIdOld?.classList.add('hidden');
            const tierIdAttributeDiscount = document.querySelector('#tierIdAttributeDiscount'+tierId+'-'+optionalId); tierIdAttributeDiscount?.classList.remove('hidden');
            const tierIdAttributeOld = document.querySelector('#tierIdAttributeOld'+tierId+'-'+optionalId); tierIdAttributeOld?.classList.remove('hidden');
        }

        if (!tierId && optionalId && optionalId in minPricesByAttribute) {
            const { min_prices } = minPricesByAttribute[optionalId];

            if( min_prices?.discount_percentage === 0) {
                const tierIdDiscount = document.querySelector('#tierIdDiscount'+optionalId); tierIdDiscount?.classList.add('hidden');
            }
            if( min_prices?.sale_price_displayed === null) {
                const tierIdOld = document.querySelector('#tierIdOld'+optionalId); tierIdOld?.classList.add('hidden');
            }

            if( type === 'price') { return min_prices?.sale_price_displayed; }
            if( type === 'old') { return min_prices?.price_displayed; }
            if( type === 'discount') { return '-'+min_prices?.discount_percentage+'%'; }
        }

        if (!tierId) {
            return null;
        }

        try {
            const tierIdNum = parseInt(tierId, 10);

            const { [tierIdNum]: attribute } = minPricesByAttribute;
            const { min_prices: pricing }: { min_prices: TPrice } = optionalId
                ? attribute[optionalId]
                : attribute;

            if( pricing?.discount_percentage == 0) {
                const tierIdAttributeDiscount = document.querySelector('#tierIdAttributeDiscount'+tierId+'-'+optionalId); tierIdAttributeDiscount?.classList.add('hidden');
            }
            if( pricing?.sale_price_displayed == null) {
                const tierIdAttributeOld = document.querySelector('#tierIdAttributeOld'+tierId+'-'+optionalId); tierIdAttributeOld?.classList.add('hidden');
            }

            if( type === 'price') { return pricing?.sale_price_displayed; }
            if( type === 'old') { return pricing?.price_displayed; }
            if( type === 'discount') { return '-'+pricing?.discount_percentage+'%'; }

        } catch {
            if (!optionalId) {
                return null;
            }

            const { min_prices } = minPricesByAttribute[optionalId];

            if( type === 'price') { return min_prices?.sale_price_displayed; }
            if( type === 'old') { return min_prices?.price_displayed; }
            if( type === 'discount') { return '-'+min_prices?.discount_percentage+'%'; }

        }
    },

    getActualPrice() {
        const price = document.querySelector('.js-price')?.textContent;
        const promotion = document.querySelector(
            '.js-price-promotion'
        )?.textContent;
        const oldPrice = document.querySelector('.js-price-old')?.textContent;

        return {
            price,
            promotion,
            oldPrice,
        };
    },
    validateEmbroideryText(text: string) {
        return text.replace(/[^a-zA-Z0-9 \-]/g, '');
    },
    setCustomization() {
        this.customization.embroideryText = this.validateEmbroideryText(this.customization.embroideryText);

        const customizations: NodeListOf<HTMLInputElement> =
            document.querySelectorAll('textarea.product-message');

        Object.entries(this.customization).forEach(([key, value], index) => {
            //console.log('Key:', key, 'Value:', value);
            if (key != 'autogrip' && index + 1 > customizations.length) {
                return;
            }

            if (
                key.startsWith('embroidery') &&
                this.customization['embroideryText'].trim() === ''
            ) {
                this.customizationForm.set(customizations[index].name, '');

                return;
            }

            if (key === 'version') {
                const input = document.querySelector(
                    '#vehicle_specifications'
                ) as HTMLInputElement;

                if (input) input.value = value;
            }

            if (key === 'version' && value === '') {
                return;
            }

            if (key === 'talonnette') {
                const input = document.querySelector(
                    '#product_heel_pad'
                ) as HTMLInputElement;
                input.value = value;
            }

            if (key === 'talonnette' && value === '0') {
                return;
            } else if (key === 'talonnette' && value) {
                this.customizationForm.set(customizations[8].name, value);
                return;
            }

            if (key === 'autogrip') {
                const input = document.querySelector(
                    '#product_autogrip'
                ) as HTMLInputElement;
                input.value = value;
            }

            if (key === 'autogrip' && value === '0') {
                return;
            } else if (key === 'autogrip' && value) {
                this.customizationForm.set(customizations[9].name, value);
                return;
            }

            this.customizationForm.set(customizations[index].name, value);
        });

        const embroidery = document.querySelector(
            'input[name="embroidery"]'
        ) as HTMLInputElement;
        if (embroidery && this.customization['embroideryText'].trim() !== '') {
            embroidery.value = this.customization['embroideryPlacement'];
        } else {
            embroidery.value = '';
        }

        const embroideryType = document.querySelector(
            'input[name="embroidery_type"]'
        ) as HTMLInputElement;
        if (embroideryType) {
            embroideryType.value = this.customization['embroideryText'].trim() !== ''
                ? (this.customization['embroideryPosition'] || 'CLASSIC')
                : '';
        }

        this.updateProduct();
    },

    setEmbroidery() {
        this.disabledAddToCart();
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';

        if (this.customization.embroideryText != '') {
            this.customization.embroideryFont
                ? ''
                : (this.customization.embroideryFont = 'ARIAL');
            this.customization.embroideryColor
                ? ''
                : (this.customization.embroideryColor = 'BLANC');
            if ([5, 13, 19, 22, 27, 29, 30].includes(this.product.id)) {
                this.customization.embroideryPosition
                    ? ''
                    : (this.customization.embroideryPosition = 'CLASSIC');
            }

            if ([4, 5, 7, 13, 14, 18, 19, 21, 22, 27, 29, 30].includes(this.product.id)) {
                this.customization.embroideryPlacement
                    ? ''
                    : (this.customization.embroideryPlacement = 'AVC');
            }
        } else {
            this.customization.embroideryFont = '';
            this.customization.embroideryColor = '';
            this.customization.embroideryIcon = '';
            this.customization.embroideryPosition = '';
            this.customization.embroideryPlacement = '';
        }

        this.updateProduct();
    },

    resetEmbroidery() {
        this.disabledAddToCart();
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';

        this.customization.embroideryText = '';
        this.customization.embroideryFont = '';
        this.customization.embroideryColor = '';
        this.customization.embroideryIcon = '';
        this.customization.embroideryPosition = '';
        this.customization.embroideryPlacement = '';

        this.embroideryImageUrl = this.getEmbroideryImageUrl();
        this.setCustomization();
    },

    submitSnowSocks() {
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';
        this.pendingRequest = true;

        const { length, height, diameter } = this.snowSocks;
        const id = `${length}/${height}R${diameter}`;

        const el = document.querySelector(
            `input[name="${id}"]`
        ) as HTMLInputElement;

        if (!el) {
            this.snowSocks.status = 'error';
            this.disabledAddToCart();
            return;
        }

        if (el.getAttribute('data-quantity') === '0') {
            this.snowSocks.status = 'unavailable';
            this.disabledAddToCart();
            return;
        }

        const select = document.querySelector(
            `#group_14 > option[title="${el.value}"]`
        ) as HTMLFormElement;
        if (select) {
            select.selected = 'selected';
        }
        this.snowSocks.status = 'success';

        this.updateProduct();
    },

    /**
     * Get the most important attribute id that will be
     * use to get the price of others attributes
     *
     * @returns { string } Attribute ID
     */
    getTierId(): string | undefined {
        const keys = Object.keys(minPricesByAttribute);

        const group = Object.entries(groups).find(([_, group]) => {
            const groupKeys = Object.keys(group.attributes);

            return keys.every((key) => groupKeys.includes(key));
        });

        return group?.[0];
    },

    getSelectedTier(): string | null {
        const tierId = this.getTierId();

        if (!tierId) {
            const el = document.querySelector(
                `input[data-product-attribute]:checked`
            ) as HTMLInputElement;

            return el?.value;
        }

        const el = document.querySelector(
            `input[data-product-attribute="${tierId}"]:checked`
        ) as HTMLInputElement;

        return el?.value;
    },

    resetCover() {
        for (const groupId of [2, 3, 4, 5, 6, 7, 16, 17]) {
            const el = document.querySelector(
                `input[data-product-attribute="${groupId}"]:checked`
            ) as HTMLInputElement;

            if (!el) {
                continue;
            }

            el.checked = false;

            delete this.attributes[groupId];
        }
        
        // Masquer immédiatement le conteneur d'images zoom
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        if (zoomContainer) {
            zoomContainer.style.display = 'none';
        }
    },

    resetColor() {
        for (const groupId of [2, 3, 4]) {
            const el = document.querySelector(
                `input[data-product-attribute="${groupId}"]:checked`
            ) as HTMLInputElement;

            if (!el) {
                continue;
            }

            el.checked = false;

            delete this.attributes[groupId];
            this.currentColor = '';
        }
        
        // Masquer immédiatement le conteneur d'images zoom
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        if (zoomContainer) {
            zoomContainer.style.display = 'none';
        }
    },

    resetAttributes() {
        for (const groupId of Object.keys(this.attributes)) {
            const el = document.querySelector(
                `input[data-product-attribute="${groupId}"]:checked`
            ) as HTMLInputElement;

            if (!el) {
                continue;
            }

            el.checked = false;
        }

        //const radioButtons = document.querySelectorAll('input[type="radio"]');
        const radioButtons = document.querySelectorAll('input[type="radio"]:not(.form-questions input)');
        radioButtons.forEach(radio => {
            (radio as HTMLInputElement).checked = false;
        });

        this.attributes = {};
        this.tierId = null;
        this.colorId = null;
        this.material = null;
        this.currentStyle = '';
        this.currentColor = '';
        this.currentMaterial = '';
        this.customization.talonnette = '0';
        this.customization.autogrip = '0';
        this.disabledAddToCart();
        
        // Masquer immédiatement le conteneur d'images zoom
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        if (zoomContainer) {
            zoomContainer.style.display = 'none';
        }
    },

    resetAttributesAfterSeats() {
        const currentVehicle = this.vehicle;
        const currentChoices = this.choices;
        const seatsGroupId = this.inputs['seats'];

        //const radioButtons = document.querySelectorAll('input[type="radio"]');
        const radioButtons = document.querySelectorAll('input[type="radio"]:not(.form-questions input)');
        radioButtons.forEach(radio => {
            const name = (radio as HTMLInputElement).name;
            // No resetear los radios del vehículo ni del grupo de seats actual
            if (!name.includes('vehicle') && !name.includes(`group_${seatsGroupId}`)) {
                (radio as HTMLInputElement).checked = false;
            }
        });

        const preservedAttributes: { [key: string]: string } = {};
        for (const [key, value] of Object.entries(this.attributes)) {
            if (key === seatsGroupId) {
                preservedAttributes[key] = value;
            }
        }
        this.attributes = preservedAttributes;

        this.colorId = null;
        this.material = null;
        this.currentStyle = '';
        this.currentColor = '';
        this.currentMaterial = '';
        this.customization.talonnette = '0';
        this.customization.autogrip = '0';
        this.vehicle = currentVehicle;
        this.choices = currentChoices;

        this.disabledAddToCart();
        
        // Masquer immédiatement le conteneur d'images zoom
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        if (zoomContainer) {
            zoomContainer.style.display = 'none';
        }
    },

    resetAttributesAfterMaterial() {
        const currentVehicle = this.vehicle;
        const currentChoices = this.choices;
        const materialGroupId = this.inputs['finition'];
        const seatsGroupId = this.inputs['seats'];

        const materialEl = document.querySelector(
            `input[data-product-attribute="${materialGroupId}"]:checked`
        ) as HTMLInputElement;

        for (const groupId of Object.keys(this.attributes)) {
            const el = document.querySelector(
                `input[data-product-attribute="${groupId}"]:checked`
            ) as HTMLInputElement;

            if (!el || groupId === materialGroupId) {
                continue;
            }

            el.checked = false;
            delete this.attributes[groupId];
        }

        if (materialEl) {
            const preservedAttributes: { [key: string]: string } = {};
            preservedAttributes[materialGroupId] = materialEl.value;
            this.attributes = preservedAttributes;

            this.material = parseInt(materialEl.value, 10);

            this.currentMaterial = materialEl.getAttribute('data-name') || '';
        } else {
            this.attributes = {};
            this.material = null;
            this.currentMaterial = '';
        }

        const radioButtons = document.querySelectorAll('input[type="radio"]:not(.form-questions input)');
        radioButtons.forEach((radio) => {
            const inputRadio = radio as HTMLInputElement;
            inputRadio.checked = false;
            inputRadio.blur();
        });

        this.tierId = null;
        this.currentStyle = '';
        this.currentColor = '';

        if (!materialEl) {
            this.colorId = null;
        }

        if (this.customization) {
            this.customization.talonnette = '0';
            this.customization.autogrip = '0';
        }

        this.vehicle = currentVehicle;
        this.choices = currentChoices;

        this.disabledAddToCart();

        // Masquer immédiatement le conteneur d'images zoom
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        if (zoomContainer) {
            zoomContainer.style.display = 'none';
        }

        this.updateProduct();
    },

    set2pieces(groupId: string, id: string) {
        //console.log('set2pieces', groupId, id);
        if( groupId === '8') {
            const elautogrip0 = document.querySelector(`input[name="autogrip"][value="0"]`) as HTMLInputElement;
            const elautogrip2 = document.querySelector(`input[name="autogrip"][value="2"]`) as HTMLInputElement;
            const elplastique0 = document.querySelector(`input[name="plastique"][value="0"]`) as HTMLInputElement;
            const elplastique2 = document.querySelector(`input[name="plastique"][value="2"]`) as HTMLInputElement;
            const elunitaire = document.querySelector(`[role="switch"][data-extra-driver]`) as HTMLButtonElement;
            const spanunitaire = document.querySelector(`[role="switch"][data-extra-driver] span`) as HTMLSpanElement;


            const elembroideryAVAR = document.querySelector(
                'select[name="selectEmbroidery"] option[value="AVAR"]'
            ) as HTMLSelectElement;

            if (elautogrip0 && elautogrip2) {
                if (id === '71' || id === '110') {
                    elautogrip0.checked = true;
                    elautogrip2.disabled = true;
                    if(elautogrip2){
                        const parentelautogrip2 = elautogrip2.parentElement as HTMLDivElement;    
                        parentelautogrip2.classList.add('opacity-50');
                        parentelautogrip2.parentElement?.classList.add('hidden');
                    }
                    if(elembroideryAVAR){
                        elembroideryAVAR.disabled = true;
                        elembroideryAVAR.setAttribute('disabled', 'disabled');
                    }
                }else{
                    elautogrip2.disabled = false;
                    if(elautogrip2){
                        const parentelautogrip2 = elautogrip2.parentElement as HTMLDivElement;    
                        parentelautogrip2.classList.remove('opacity-50');
                        parentelautogrip2.parentElement?.classList.remove('hidden');
                    }
                    if(elembroideryAVAR){
                        elembroideryAVAR.disabled = false;
                        elembroideryAVAR.removeAttribute('disabled'); 
                    }
                }                
            }
            
            if (elplastique0 && elplastique2 && id === '110') {
                elplastique0.checked = true;
                elplastique2.disabled = true;
                if(elplastique2){
                    const parentelplastique2 = elplastique2.parentElement as HTMLDivElement;    
                    parentelplastique2.classList.add('opacity-50');
                    parentelplastique2.parentElement?.classList.add('hidden');
                }
            }else{
                elplastique0.checked = true;
                elplastique0.disabled = false;
                elplastique2.disabled = false;
                if(elplastique2){
                    const parentelplastique2 = elplastique2.parentElement as HTMLDivElement;    
                    parentelplastique2.classList.remove('opacity-50');
                    parentelplastique2.parentElement?.classList.remove('hidden');
                }
            }

            if (elunitaire && spanunitaire) {
                if (id === '110') {
                    elunitaire.disabled = true;
                    elunitaire.ariaChecked = 'false';
                    elunitaire.setAttribute('disabled', 'disabled');
                    elunitaire.setAttribute('aria-checked', 'false');

                    elunitaire.classList.add('bg-gray-700','border-gray-500');
                    elunitaire.classList.remove('bg-green-400','border-green-600');
                    spanunitaire.classList.add('translate-x-0');
                    spanunitaire.classList.remove('translate-x-6');
                }else{
                    elunitaire.disabled = false;
                    elunitaire.ariaChecked = 'false';
                    elunitaire.removeAttribute('disabled');
                    elunitaire.setAttribute('aria-checked', 'false');

                }
            }
            
            this.customization.talonnette = '0';
            this.customization.autogrip = '0';
            this.customization.embroideryPlacement = '';
        } 
    },

    checkAttribute(groupId: string, id: string, select?: boolean) {
        // Gestion des priorités pour les groupes 5, 6, 7 (5 : "maille avec surpiqure", 6 : "maille ou simili", 7 : "simili")
        const priorityGroups = ['5', '6', '7'];
        if (priorityGroups.includes(groupId)) {
            const otherGroups = priorityGroups.filter(g => g !== groupId);
            otherGroups.forEach(otherGroupId => {
                // Désélectionner les <input type="radio">
                const inputs = document.querySelectorAll(
                    `input[data-product-attribute="${otherGroupId}"]:checked`
                ) as NodeListOf<HTMLInputElement>;

                inputs.forEach(input => {
                    input.checked = false;
                });

                // Désélectionner aussi les <option> dans les <select> s'il y en a
                const select = document.querySelector(
                    `select[data-product-attribute="${otherGroupId}"]`
                ) as HTMLSelectElement;
                if (select) {
                    select.selectedIndex = 0;
                    Array.from(select.options).forEach(opt => {
                        opt.removeAttribute('selected');
                    });
                }
            });
        }
        // Sélection de l'attribut courant
        if (select) {
            const el = document.querySelector(
                `.product-variants-item > select[data-product-attribute="${groupId}"]`
            ) as HTMLSelectElement;

            // Select option
            for (const option of el.options) {
                if (option.value === id) {
                    option.selected = true;
                    option.setAttribute('selected', 'selected');
                }
            }
        } else {
            const el = document.querySelector(
                `input[data-product-attribute="${groupId}"][value="${id}"]`
            ) as HTMLInputElement;
            el.checked = true;
        }
    
        // Traitement spécifique selon l'ID produit
        let eventype: string | undefined;
        if (this.product.id === 7) { eventype = 'finition'; }
        if ( [4, 5, 13, 14, 18, 19, 22, 27, 29, 30].includes(this.product.id) ) {
            eventype = 'seats';
        }

        if (eventype !== undefined) {
            const choicesGrp = document.querySelectorAll(`.event-${eventype} input`);
            choicesGrp.forEach((element) => {
                element.removeAttribute('disabled');
            });
        }

        this.attributes[groupId] = id;

        // Update tier (DOM attributes changes are not reactive)
        this.tierId = this.getSelectedTier();

        if (groupId === '1') {
            this.colorId = Number(id);
        }

        // Filtrer les images zoom en fonction de l'attribut sélectionné
        this.filterZoomImages(groupId, id);

        // Update product
        this.updateProduct();
    },
    /**
     * Get the checked attribute value
     * @param { string } groupId Data Product Attribute ID
     * @returns { string } The value of the checked attribute
     */
    getAttribute(groupId: string | number, isSelect = false): string {
        if (isSelect) {
            const el = document.querySelector(
                `select[data-product-attribute="${groupId}"] > :checked`
            ) as HTMLOptionElement;
            return el.value;
        }

        const el = document.querySelector(
            `input[data-product-attribute="${groupId}"]:checked`
        ) as HTMLInputElement;
        return el.value;
    },

    /**
     * Filter zoom images based on the attribute that was just selected.
     * Only the attribute (groupId/id) that triggered the selection is used,
     * avoiding false positives from other simultaneously checked groups.
     * Format expected: 109-127-1.jpg (must contain -127-)
     */
    filterZoomImages(groupId?: string, attrId?: string) {
        const zoomContainer = document.querySelector('.js-zoom-container') as HTMLElement;
        const zoomImages = document.querySelectorAll('.js-zoom-image-item');

        // If no attribute id provided (e.g. called from reset), hide everything
        if (!attrId) {
            zoomImages.forEach((img) => {
                (img as HTMLElement).style.display = 'none';
            });
            if (zoomContainer) {
                zoomContainer.style.display = 'none';
            }
            return;
        }

        // Filter images: show only those whose filename contains the selected attribute ID
        let visibleCount = 0;
        zoomImages.forEach((img) => {
            const imageId = (img as HTMLElement).getAttribute('data-image-id');
            const shouldShow = !!(imageId && imageId.includes('-' + attrId + '-'));

            (img as HTMLElement).style.display = shouldShow ? '' : 'none';
            if (shouldShow) {
                visibleCount++;
            }
        });

        // Show/hide container based on visible images count
        if (zoomContainer) {
            zoomContainer.style.display = visibleCount > 0 ? '' : 'none';
        }
    },

    updateProduct() {
        try {
            this.pendingRequest = true;

            prestashop.emit('updateProduct', {
                eventType: 'updatedProductCombination',
                resp: {},
                reason: {
                    productUrl: prestashop.urls.pages.product || '',
                },
            });
        } catch (err) {
            console.warn(err); 
        }
    },

    setTalonnette() {
        this.disabledAddToCart();
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';

        this.updateProduct();
    },

    setAutogrip() {
        this.disabledAddToCart();
        loader.style.display = 'block';
        loaderOverlay.style.display = 'block';

        this.updateProduct();
    },

    async selectVehicle(id: string) {
        this.dropdown = false;
        this.resetAttributes();

        this.vehicle = this.vehicles.find((v) => v.id_vehicle === id);
        // Description uses the store (located in product.tpl)
        this.$store.vehicle = this.vehicle;

        if(this.product.id === 8) { // Baches
            await this.checkSizeBaches(id);
        }

        // Description uses the store (located in product.tpl)
        this.$store.vehicle = this.vehicle;
        if ([8, 9, 32, 37, 38].indexOf(this.product.id) === -1) {
            await this.getQuestion();
        }

        let eventype: string | undefined;
        if (this.product.id === 7) { eventype = 'finition'; }
        if ( [4, 5, 13, 14, 18, 19, 22, 27, 29, 30].includes(this.product.id) ) {
            eventype = 'seats';
        }

        if(eventype !== undefined) { 
            if (this.$store.needAnswer === true) {
                setTimeout(() => {
                    const choicesGrp = document.querySelectorAll(`.event-`+ eventype +` input`);
                    choicesGrp.forEach((element) => {
                        element.setAttribute('disabled', 'disabled');
                    });
                }, 500);
            }else{
                setTimeout(() => {
                    const choicesGrp = document.querySelectorAll(`.event-`+ eventype +` input`);
                    choicesGrp.forEach((element) => {
                        element.removeAttribute('disabled');
                    });
                }, 1000);
            }
        }

            
        const elements = document.querySelectorAll(
            '[data-vehicle-id="' + id + '"]'
        );
        this.choices = Array.from(elements)
            .map((el) => el.getAttribute('data-attribute-id'))
            .filter((e) => e !== null) as string[];

        try {
            const newMaterialsAvailable = this.$el.querySelector(
                'meta.new_materials_available'
            ) as HTMLMetaElement;
            if (newMaterialsAvailable.getAttribute('value') === '1') {
                document
                    .querySelectorAll('.js-filtered-option')
                    .forEach((el) => {
                        if (
                            ['61', '66', '69'].includes(
                                el.getAttribute('data-attribute-id') ?? ''
                            )
                        ) {
                            el.classList.remove('hidden');
                        }
                    });
            } else {
                document
                    .querySelectorAll('.js-filtered-option')
                    .forEach((el) => {
                        if (
                            ['61', '66', '69'].includes(
                                el.getAttribute('data-attribute-id') ?? ''
                            )
                        ) {
                            el.classList.add('hidden');
                        }
                    });
            }
        } catch {
            // Error when the product does not support new materials
        }
    },
    setCoverMedia(url?: string) {
        if (!url) {
            url = document.querySelector('.js-cover-img')?.getAttribute('src') ?? '';
        }

        const imgs = document.querySelectorAll('.js-cover-img');
        imgs.forEach((img) => {
            img.setAttribute('src', url!);
            img.setAttribute('srcset', url!);
        });

        // Vérifier si l'URL contient 2 traits d'union entourés de chiffres
        const digitHyphenPattern = /\d+-\d+-\d+/;
        if (url && digitHyphenPattern.test(url)) {
            const selectImgTalonnette = document.getElementById('selectImgTalonnette');
            if (selectImgTalonnette) {
                (selectImgTalonnette as HTMLInputElement).value = url;
            }
        }
    },
    switchCoverMedia(type?: string) {
        //let imgs = document.querySelectorAll('.js-cover-img');
        let imgs: HTMLImageElement[] = Array.from(
            document.querySelectorAll<HTMLImageElement>('.js-cover-img')
        );
        const coverTypes = ['pvc', 'avec', 'sans', 'autogrip'];
        
        // Vérifier si les images contiennent "autogrip" dans leur src
        const hasAutogrip = imgs.some((img) => {
            const src = img.getAttribute('src');
            return src && src.includes('/autogrip/');
        });
        
        // Si les images contiennent autogrip OU si on switch vers avec/sans/pvc, utiliser l'input
        if ((type !== undefined && coverTypes.includes(type)) || hasAutogrip) {
            const selectedImgSrc = (document.getElementById('selectImgTalonnette') as HTMLInputElement).value;
            
            if (hasAutogrip || type === 'avec' || type === 'sans' || type === 'pvc') {
                // Chercher toutes les images qui correspondent au pattern de base
                imgs = imgs.filter((img) => {
                    const imgSrc = img.getAttribute('src');
                    if (imgSrc) {
                        // Si l'image contient autogrip, on la sélectionne
                        if (imgSrc.includes('/autogrip/')) {
                            return true;
                        }
                        // Nettoyer l'URL de l'image et de l'input pour comparaison
                        const cleanImgSrc = this.getCleanFilename(imgSrc);
                        const cleanInputSrc = this.getCleanFilename(selectedImgSrc);
                        return cleanImgSrc === cleanInputSrc;
                    }
                    return false; 
                });
            } else {
                // Pour les autres cas, utiliser la logique existante
                imgs = Array.from(document.querySelectorAll<HTMLImageElement>(`img[src="${selectedImgSrc}"]`));
            }
        }

        imgs.forEach((img) => {
            let newsrc = img.getAttribute('src');
            let newsrcset = img.getAttribute('srcset');
        
            if (newsrc !== null) {
                // Si l'image contenait autogrip OU si on switch vers avec/sans/pvc, utiliser l'URL de l'input
                if (newsrc.includes('/autogrip/') || type === 'avec' || type === 'sans' || type === 'pvc') {
                    const selectedImgSrc = (document.getElementById('selectImgTalonnette') as HTMLInputElement).value;
                    newsrc = this.updateImageUrl(selectedImgSrc, type);
                } else {
                    newsrc = this.updateImageUrl(newsrc, type);
                }
                img.setAttribute('src', newsrc);
            }
            
            if (newsrcset !== null) {
                // Même logique pour srcset
                if (newsrcset.includes('/autogrip/') || type === 'avec' || type === 'sans' || type === 'pvc') {
                    const selectedImgSrc = (document.getElementById('selectImgTalonnette') as HTMLInputElement).value;
                    newsrcset = this.updateImageUrl(selectedImgSrc, type);
                } else {
                    newsrcset = this.updateImageUrl(newsrcset, type);
                }
                img.setAttribute('srcset', newsrcset);
            }
        });
    },
    // Nouvelle fonction helper pour extraire le nom de fichier de base
    getCleanFilename(url: string): string {
        const filename = url.split('/').pop() || '';
        // Retirer les suffixes et garder seulement le nom de base
        return filename.replace(/(-sans-talonnette|-avec-talonnette|-avec-plastique)(\.[^.]+)$/, '$2');
    },
    updateImageUrl(url: string, type?: string): string {
        // Nettoyer d'abord tous les types existants de l'URL
        let cleanUrl = url.replace(/\/medias\/(\d+)\/(pvc|avec|sans|autogrip|view)\//g, '/medias/$1/');
        
        // Cas spécial pour autogrip : nettoyer aussi le pattern /medias/autogrip/
        cleanUrl = cleanUrl.replace(/\/medias\/autogrip\//g, '/medias/');
        
        // Nettoyer le nom du fichier des suffixes existants
        cleanUrl = cleanUrl.replace(/(-sans-talonnette|-avec-talonnette|-avec-plastique)(\.[^.]+)$/, '$2');
        
        //console.log('Clean URL:', cleanUrl);
        
        // Si type est undefined, retourner l'URL nettoyée
        if (type === undefined) {
            return cleanUrl;
        }
        
        // Ajouter le type dans l'URL et modifier le nom du fichier
        if (type === 'sans' || type === 'pvc' || type === 'avec' || type === 'view') {
            const urlParts = cleanUrl.split('/');
            let filename = urlParts.pop() || '';
            
            // Modifier le nom du fichier selon le type
            if (type === 'sans') {
                filename = filename.replace(/(\.[^.]+)$/, '-sans-talonnette$1');
            } else if (type === 'avec') {
                filename = filename.replace(/(\.[^.]+)$/, '-avec-talonnette$1');
            } else if (type === 'pvc') {
                filename = filename.replace(/(\.[^.]+)$/, '-avec-plastique$1');
            }
            // Pour 'view', on garde le nom original
            
            return urlParts.join('/') + '/' + type + '/' + filename;
        }
        
        // Pour autogrip, utiliser le pattern spécial
        if (type === 'autogrip') {
            const urlParts = cleanUrl.split('/');
            const filename = urlParts.pop();
            return urlParts.join('/') + '/autogrip/' + filename;
        }

        // Si aucun type spécifié, retourner l'URL nettoyée
        return cleanUrl;
    },
    setCoverImg(url?: string) {
        if (!url) {
            url = document.querySelector('.js-cover-img')?.getAttribute('src') ?? '';
        }
        //console.log('1...' + url + ' ' + this.customization.talonnette);
        if ( url.includes('avec-talonnette') ) { 
            if(!url.includes('camping/') && !url.includes('utilitaire/') && !url.includes('autogrip/')) {
                url = url.replace('-avec-talonnette.jpg', '.jpg'); 
            }
        }
        //console.log('2...' + url + ' ' + this.customization.talonnette);
        if ( url.includes('avec-plastique') ) { 
            if(!url.includes('camping/') && !url.includes('utilitaire/') && !url.includes('autogrip/')) {
                url = url.replace('-avec-plastique.jpg', '.jpg'); 
            }
        }
        //console.log('3...' + url + ' ' + this.customization.talonnette);
        if ( this.customization.talonnette === '1' && !url.includes('filter') && !url.includes('autogrip/') &&
            (url.match(/-/g) || []).length >= 2 && !url.includes('avec-talonnette') ) {
            url = url.replace('.jpg', '-avec-talonnette.jpg');
        } 
        //console.log('4...' + url + ' ' + this.customization.talonnette);
        if ( this.customization.talonnette === '2' && !url.includes('filter') && !url.includes('autogrip/') &&
            (url.match(/-/g) || []).length >= 2 && !url.includes('avec-plastique') ) {
                url = url.replace('.jpg', '-avec-plastique.jpg');
        }
        //console.log('5...' + url + ' ' + this.customization.talonnette);
        const imgs = document.querySelectorAll('.js-cover-img');
        imgs.forEach((img) => {
            img.setAttribute('src', url!);
            img.setAttribute('srcset', url!);
        });
        // Vérifier si l'URL contient 2 traits d'union entourés de chiffres
        const digitHyphenPattern = /\d+-\d+-\d+/;
        if (url && digitHyphenPattern.test(url)) {
            const selectImgTalonnette = document.getElementById('selectImgTalonnette');
            if (selectImgTalonnette) {
                (selectImgTalonnette as HTMLInputElement).value = url;
            }
        }
    },

    switchCoverImg(type?: string) {
        const imgs = document.querySelectorAll('.js-cover-img');
        imgs.forEach((img) => {
          let newsrc = img.getAttribute('src');
          let newsrcset = img.getAttribute('srcset');
      
          if (newsrc !== null && type !== undefined) {
            const regex = new RegExp(`${type}new`, 'g');
            if ((newsrc?.match(/-/g)?.length ?? 0) >= 2 && !newsrc.match(regex)) {
              newsrc = newsrc.replace(type, `${type}new`);
              img.setAttribute('src', newsrc!);
            }
          }
          if (newsrcset !== null && type !== undefined) {
            const regex = new RegExp(`${type}new`, 'g');
            if ((newsrcset?.match(/-/g)?.length ?? 0) >= 2 && !newsrcset.match(regex)) {
              newsrcset = newsrcset.replace(type, `${type}new`);
              img.setAttribute('srcset', newsrcset!);
            }
          }
          //console.log(img.getAttribute('src'));
          //console.log(img.getAttribute('srcset'));
        });
      },

    setTemplateCode(attributeId: number, designOffice: boolean = false) {
        this.$store.incorrectTemplateCode = '';
        const templateCode = document.querySelector(
            'meta[name*=template][data-vehicle-id="' +
                this.vehicle?.id_vehicle +
                '"][data-attribute-id="' +
                attributeId +
                '"]'
        ) as HTMLMetaElement;
        const templateCodeDefault = document.querySelector(
            'meta[name="template_code"][data-vehicle-id="' +
                this.vehicle?.id_vehicle +
                '"]'
        ) as HTMLInputElement;

        if (this.$store.needAnswer === true) return;

        if (templateCodeDefault) {
            this.customization.templateCode = templateCodeDefault.getAttribute(
                'value'
            ) as string;
        }else if (templateCode) {
            this.customization.templateCode = templateCode.getAttribute(
                'value'
            ) as string;
        }
        
        if(designOffice) {
            this.pendingRequest = true;
            loader.classList.add('!block');
            loaderOverlay.classList.add('!block');
            document.body.classList.add('overflow-hidden', 'h-screen');

            this.hasDesignOffice(this.customization.templateCode, attributeId);
        } else {
            loader.classList.remove('!block');
            loaderOverlay.classList.remove('!block');
            document.body.classList.remove('overflow-hidden', 'h-screen');
        }
    },

    async hasDesignOffice(templateCode: string, attributeId: number) {
        if(templateCode !== 'NODESIGNOFFICE') {
            loader.classList.remove('!block');
            loaderOverlay.classList.remove('!block');
            document.body.classList.remove('overflow-hidden', 'h-screen');
            this.pendingRequest = false;
            return;
        }

        const response = fetch(`/modules/tailor/webservice/template-survey-ajax.php?id_product=${this.product.id}&id_vehicle=${this.vehicle?.id_vehicle}&id_attribute=${attributeId}`)
        .then((response) => response.json())
        .then((responseJson) => {
            if (responseJson.can_be_ordered == false) {
                this.$store.incorrectTemplateCode = true;
            } else {
                this.$store.incorrectTemplateCode = false;
            }

            loader.classList.remove('!block');
            loaderOverlay.classList.remove('!block');
            document.body.classList.remove('overflow-hidden', 'h-screen');
            this.pendingRequest = false;
        });
    },
}));
